<template>
    <div id="product__panelists--edit">
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0">Date:</v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top pa-0 ma-0">
                <DatePicker label="Date" :date="pp_date" @choose="chooseDate" :disable_future="true"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align  pa-0 ma-0">Invitation Id:</v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top  pa-0 ma-0">
                <v-text-field  class="ma-0 pa-0"  label="Invitation Id" outlined dense v-model="invitation_id"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align  pa-0 ma-0">Last 4 digits</v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top  pa-0 ma-0">
                <v-text-field  label="Last 4 digits" outlined dense class="ma-0 pa-0" v-model="tracking_id"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="4" class="text-right no-right no-bottom no-top middle-align  pa-0 ma-0"></v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top  pa-0 ma-0">
                <v-btn small color="primary" @click="close()">Close</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DatePicker from './../../utilities/DatePicker'

export default {
    name: 'EditPanelist',
    data: () => ({
        pp_date: '',
        invitation_id: '',
        tracking_id: '',
    }),
    components: {
        DatePicker
    },
    props: [
        'index'
    ],
    mounted() {
        var view = this,
            pans = view.$store.getters['ProductData/getPanelists']
        if (pans !== null) {
            if (pans.length >= view.index) {
                var current_pan = pans[view.index]
                view.pp_date = current_pan.pp_date
                view.invitation_id = current_pan.invitation_id
                view.tracking_id = current_pan.tracking_id
            }
        }
    },
    methods: {
        chooseDate: function(d) {
            this.pp_date = d
            this.$store.dispatch('ProductData/editPanelist', {key: 'pp_date', val: d, index: this.index})
        },
        close: function() {
            this.$emit('closeEditPanelist', false)
            this.$emit('editDate');
        }
    },
    watch: {
        invitation_id: function(d) {
            this.$store.dispatch('ProductData/editPanelist', {key: 'invitation_id', val: d, index: this.index})
        },
        tracking_id: function(d) {
            this.$store.dispatch('ProductData/editPanelist', {key: 'tracking_id', val: d, index: this.index})
        }
    }
}
</script>
<style lang="sass" scoped>
@import './../../assets/sass/product/product'
</style>